import { getRequest } from '../../../core/utils/api';
import { type KeycloakContext } from '../../authentication/keycloak/KeycloakProvider';
import type Facility from '../../facilities/models/facility';

const getAllFacilitiesForOffice = async (officeId: string | undefined, keycloak: KeycloakContext): Promise<Facility[] | undefined> => {
  if (officeId === undefined) {
    return undefined;
  }

  const apiResponse = await getRequest<Facility[]>(`facility/office-id/${officeId}`, keycloak);
  if (apiResponse.error) {
    return undefined;
  }
  return apiResponse.json;
};

export default getAllFacilitiesForOffice;
